import React, { forwardRef } from 'react'
import styled from 'styled-components'

export const Wrapper = styled.div``

export const EmptyWrapper = styled.div`
  display: grid;
  place-items: center;
  padding-block: 2rem; 
`

const StyledItem = styled.div`
  user-select: none;
  display: grid;
  grid-template: "selector content" / 50px 1fr;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;

  .item-selector {
    transition: background-color 0.1s ease;

    &:hover {
      background: #eff0f0;
    }

    .circle {
      background: #fff;
    }
  }

  .item-content {
    grid-area: content;
    border: none;
    background: none;
    padding: 10px 10px 10px 4px;
    display: grid;
    gap: 8px 4px;
    grid-template:
      "title title requester-assignees"
      "due-date target-achievement status"
      "memo memo memo"
      / auto 1fr 140px;
    text-align: left;
    color: #333;
  }

  .title {
    grid-area: title;
    font-weight: bold;
  }

  .requester-assignees {
    grid-area: requester-assignees;
    align-self: start;
    display: flex;
    align-items: center;
    gap: 2px;
    font-size: 10px;
  }

  .due-date {
    grid-area: due-date;
    align-self: center;
    display: flex;
    gap: 4px;
    font-size: 0.7rem;
  }

  .target-achievement {
    grid-area: target-achievement;
    align-self: center;
    font-size: 0.7rem;
    padding-left: 0.5rem;
    display: flex;
    gap: 4px;

    span {
      font-size: 0.8em;
    }
  }

  .status {
    grid-area: status;
    color: #333333aa;
    padding: 0.2rem 0;
    border-radius: 4px;
    display: grid;
    place-items: center;

    &.not-started {
      background: ${({ theme }) => theme.task_not_started};
    }
    &.in-progress {
      background: ${({ theme }) => theme.task_in_progress};
    }
    &.completed {
      background: ${({ theme }) => theme.task_completed};
    }
  }

  .memo {
    grid-area: memo;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    font-size: 0.7rem;
  }
`

export const Item = forwardRef(({ children, className, ...rest }, ref) => (
  <StyledItem
    className="item"
    {...rest}
    ref={ref}
  >
    {children}
  </StyledItem>
))
